<app-topnav [pageName]="pageName"></app-topnav>

<div class="h-30"></div>
<div class="container" [hidden]="!hideReviewPanel">
  <div class="content" role="main">
    <div class="facility-heading">Add Material</div>
    <form #rpform="ngForm">
      <div class="designatedFacilityForm">

        <div class="form-fields">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Material Name</mat-label>
            <input matInput class="form-control-textbox" [(ngModel)]="material.materialName" name="name" />
          </mat-form-field>
          @if (isSubmitted && (material.materialName === null || material.materialName === undefined || material.materialName === '')) {
            <mat-error class="validation-error">Material Name is required</mat-error>
          }
        </div>
        <div class="mb-10"></div>
        <div class="form-fields">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Type</mat-label>
            <mat-select placeholder="Select Type" name="materialType" [(ngModel)]="material.materialType" required>
              @for (mt of materialTypes; track mt) {
                <mat-option [value]="mt.id">{{
                mt.type}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (isSubmitted && material.materialType == 0) {
            <mat-error class="validation-error">Material Type is required</mat-error>
          }
        </div>
        <div class="mb-10"></div>
        <div class="form-fields">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Language</mat-label>
            <mat-select placeholder="Select Type" name="materiallanguage" [(ngModel)]="material.language" required>
              @for (ml of materialLanguage; track ml) {
                <mat-option [value]="ml.id">{{
                ml.description}}</mat-option>
              }
            </mat-select>

          </mat-form-field>
          @if (isSubmitted && material.language ==0) {
            <mat-error class="validation-error">Language is required</mat-error>
          }
        </div>
        <div class="mb-10"></div>
        <div class="form-fields">
          <mat-form-field>
            <mat-label>Tags</mat-label>
            <mat-select placeholder="Select" name="materialtags" multiple [(value)]="selectedTags" [(ngModel)]="selectedTags">
              <mat-select-trigger>
                <div class="selected-pills">
                  @for (tag of selectedTags; track tag) {
                    <span class="pill">
                      {{ getTagName(tag).replace(',','') }}
                    </span>
                  }
                </div>
              </mat-select-trigger>
              @for (tag of tags; track tag) {
                <mat-option [value]="tag.id">
                  {{ tag.tagName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

        </div>
        <div class="mb-10"></div>
        <div class="material-upload-section">
          <div class="material-upload-title">Add Material</div>
          <ngx-dropzone (change)="onSelect($event)" [multiple]="false" [disabled]="isUploading || isSaving" [hidden]="isUploading || !(material.materialFileId == 0)">
            <ngx-dropzone-label>
              {{selectedFileName}}
            </ngx-dropzone-label>
          </ngx-dropzone>

          @if (isUploading) {
            <div class="upload-progress-card" [class.upload-complete]="isUploadComplete">
              <div class="upload-progress-header">
                <span class="upload-file-name">{{ selectedFileName }}</span>
                <span class="upload-percent">{{ uploadProgress }}%</span>
              </div>
              <div class="upload-progress-track">
                <div class="upload-progress-fill" [style.width.%]="uploadProgress"></div>
              </div>
              <p class="upload-progress-label">{{ isUploadComplete ? 'Uploaded successfully!' : 'Uploading material file...' }}</p>
            </div>
          }

          @if (!isUploading && material.materialFileId != 0) {
            <div class="uploaded-file-card">
              <div class="uploaded-file-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
                  <path d="M14 2v6h6" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="uploaded-file-info">
                <div class="uploaded-file-name" [title]="uploadedFileName">{{ uploadedFileName }}</div>
                <div class="uploaded-file-meta">
                  <span class="upload-success-badge">
                    <svg viewBox="0 0 16 16" width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path d="M3.5 8.5l3 3 6-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Uploaded
                  </span>
                </div>
              </div>
              <div class="uploaded-file-actions">
                <button type="button" class="file-action-btn" (click)="downloadFile()" title="Download">
                  <img src="assets/filelinkicon.svg" class="materialdownloadfile" alt="Download">
                </button>
                <button type="button" class="file-action-btn" (click)="removeMaterialFile()" title="Remove">
                  <img src="assets/trash.svg" class="materialdeletefile" alt="Remove">
                </button>
              </div>
            </div>
          }
        </div>
        @if (isSubmitted && material.materialFileId ==0) {
          <mat-error>Material File is required</mat-error>
        }
        <div class="mb-10"></div>
        <div>
          Status
          <div class="toggle">
            @for (ms of materialStatus; track ms) {
              <div class="switch-div">
                <input  type="radio" [value]="ms.key" [name]="ms.value" [id]="ms.key" [className]="ms.value.toLowerCase()" [(ngModel)]="material.status" />
                <label for="{{ms.key}}">{{ms.value}}</label>
              </div>
            }
          </div>
          @if (isSubmitted && material.status ==0) {
            <mat-error class="validation-error">Status is required</mat-error>
          }
        </div>

        <div class="mb-10"></div>

        <div class="form-buttons">
          <input type="submit" class="submit-form-button" (click)="onSubmit(rpform)" value="Submit" [disabled]="isUploading || isSaving"/>
          <a routerLink="/material-list" class="submit-form-button cancel-button">Cancel</a>
        </div>

      </div>
    </form>
  </div>
</div>

<!--review section of add tag-->


<app-footer [bbapp]="true"></app-footer>
